var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 72,
    viewBox: "0 0 62 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4043 47.5967C42.3166 47.5967 44.5523 50.7149 44.8612 54.0243C45.9643 53.4213 47.2146 53.0683 48.5678 53.0683C52.8038 53.0683 56.2456 56.5101 56.2456 60.7462C56.2456 61.7758 56.0397 62.7465 55.672 63.6438C58.2313 64.894 60.3493 68.1593 59.9522 70.5421",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 71.1304C2 68.5858 3.3679 66.3648 5.4124 65.1587L5.38298 65.1293C4.89759 64.1879 4.61813 63.1142 4.61813 61.9816C4.61813 58.1721 7.70694 55.0833 11.5165 55.0833C11.9871 55.0833 12.4578 55.1274 12.9138 55.2304C12.9138 55.1863 12.9138 55.1568 12.9138 55.1127C12.9138 51.6268 15.326 47.5819 18.8119 47.5819",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9629 60.6432C40.9629 56.466 44.3459 53.083 48.5231 53.083",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2743 60.6433C56.2743 63.4379 54.7593 65.8796 52.4941 67.1886",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61857 67.3502C6.60367 66.703 5.75057 65.8058 5.13281 64.7615",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1953 69.2184C27.1953 65.0412 30.5783 61.6582 34.7555 61.6582",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.328 63.629C28.0337 61.7904 25.9451 60.5696 23.6211 60.4225",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.297 58.2606C16.0909 56.3484 13.9582 55.0835 11.5312 55.0835",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9336 40.2424V21.2094C37.9336 17.5617 41.0077 13.7963 42.3462 12.296C43.6847 13.7963 46.7588 17.5617 46.7588 21.2094V43.1841C46.7588 45.5669 45.2879 47.5967 42.3462 47.5967H39.4045",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2822 40.2424V21.2094C20.2822 17.5617 17.2081 13.7963 15.8696 12.296C14.5311 13.7963 11.457 17.5617 11.457 21.2094V43.1841C11.457 45.5669 12.9279 47.5967 15.8696 47.5967H18.8113",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9335 41.7132V13.6198C37.9335 7.91286 33.9622 2 29.1084 2C24.2545 2 20.2832 7.91286 20.2832 13.6198V41.7132",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5213 37.3006V25.5337C33.5213 22.136 32.624 19.665 31.3738 17.7528C30.609 16.5909 27.7408 16.5909 26.9906 17.7528C25.7404 19.6502 24.6961 22.1213 24.6961 25.5337V37.3006L17.3418 44.0812V47.5966H24.7991L26.167 49.0674H32.0504L33.5654 47.5966H40.8756V44.0812L33.5213 37.3006Z",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1074 38.7715V44.6549",
    stroke: "#23262B",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartUpIcon);
export default __webpack_public_path__ + "static/media/startUpIcon.30e37ba5f822df983c47a132f4ccbfcc.svg";
export { ForwardRef as ReactComponent };